import { ApiRef, createApiRef } from '@backstage/core-plugin-api';
import { TechInsightsApi } from '@mercedes-benz/tech-insights-common';

/**
 * A Backstage ApiRef for the TechInsights API. See https://backstage.io/docs/api/utility-apis for more information on
 * Backstage ApiRefs.
 * @public
 */
export const techInsightsApiRef: ApiRef<TechInsightsApi<unknown>> =
  createApiRef<TechInsightsApi<unknown>>({
    id: 'plugin.tech-insights.api',
  });
